(() => {
  'use strict';

  if (window.__treedixProductResourcesInitialized) return;
  window.__treedixProductResourcesInitialized = true;

  const RESOURCE_ROOT = '.tl-product-resources';

  function embedVideoUrl(rawUrl) {
    try {
      const url = new URL(rawUrl, window.location.origin);
      const host = url.hostname.replace(/^www\./, '');
      if (host === 'youtu.be') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : rawUrl;
      }
      if (host === 'youtube.com' || host === 'm.youtube.com') {
        const parts = url.pathname.split('/').filter(Boolean);
        const id = url.searchParams.get('v') || parts[parts.indexOf('embed') + 1] || parts[parts.indexOf('shorts') + 1];
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : rawUrl;
      }
      if (host === 'vimeo.com') {
        const id = url.pathname.split('/').filter(Boolean)[0];
        return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : rawUrl;
      }
      if (host === 'player.vimeo.com') {
        url.searchParams.set('autoplay', '1');
        return url.toString();
      }
    } catch (error) {
      return rawUrl;
    }
    return rawUrl;
  }

  function openVideo(resources, rawUrl) {
    const modal = resources.querySelector('[data-tl-video-modal]');
    const frame = resources.querySelector('[data-tl-video-frame]');
    if (!modal || !frame || !rawUrl) return false;

    frame.innerHTML = '';
    const url = embedVideoUrl(rawUrl);
    if (/\.(mp4|webm|ogg)(\?|#|$)/i.test(url)) {
      const video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      frame.appendChild(video);
    } else {
      const iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.title = 'Product video';
      frame.appendChild(iframe);
    }

    modal.hidden = false;
    document.body.classList.add('tl-video-open');
    return true;
  }

  function closeVideo(resources) {
    const modal = resources.querySelector('[data-tl-video-modal]');
    const frame = resources.querySelector('[data-tl-video-frame]');
    if (!modal || !frame) return false;

    frame.innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('tl-video-open');
    return true;
  }

  function resourceTarget(hash) {
    const key = String(hash || '').replace(/^#/, '').toLowerCase();
    if (!key) return null;

    if (key === 'downloads' || key === 'download' || key === 'manual' || key === 'manuals') {
      return document.querySelector('.tl-product-resources__panel--downloads');
    }
    if (key === 'faq' || key === 'faqs') {
      return document.querySelector('.tl-product-resources__panel--faq');
    }
    if (key === 'video' || key === 'videos' || key === 'video-guide') {
      return document.querySelector('.tl-product-resources__panel--video');
    }
    if (key === 'product-resources' || key === 'resources') {
      return document.querySelector(RESOURCE_ROOT);
    }

    return document.getElementById(key);
  }

  document.addEventListener('click', (event) => {
    const faqButton = event.target.closest('[data-tl-resources-faq-button]');
    if (faqButton) {
      const panelId = faqButton.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      event.preventDefault();
      const isExpanded = faqButton.getAttribute('aria-expanded') === 'true';
      faqButton.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      panel.hidden = isExpanded;
      return;
    }

    const videoOpen = event.target.closest('[data-tl-video-open]');
    if (videoOpen) {
      const resources = videoOpen.closest(RESOURCE_ROOT);
      if (!resources) return;
      const modal = resources.querySelector('[data-tl-video-modal]');
      if (modal && !modal.hidden) return;
      if (openVideo(resources, videoOpen.dataset.videoUrl)) {
        event.preventDefault();
      }
      return;
    }

    const videoClose = event.target.closest('[data-tl-video-close]');
    if (videoClose) {
      const resources = videoClose.closest(RESOURCE_ROOT);
      if (!resources) return;
      if (closeVideo(resources)) event.preventDefault();
      return;
    }

    const anchor = event.target.closest('a[href^="#"]');
    if (!anchor) return;

    const target = resourceTarget(anchor.getAttribute('href'));
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (history.pushState) history.pushState(null, '', anchor.getAttribute('href'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(`${RESOURCE_ROOT} [data-tl-video-modal]:not([hidden])`).forEach((modal) => {
      const resources = modal.closest(RESOURCE_ROOT);
      if (resources) closeVideo(resources);
    });
  });
})();
